var map = {
	"./client.png": 9538,
	"./commodity.png": 3570,
	"./download.png": 4925,
	"./fitment.png": 7242,
	"./information.png": 9621,
	"./marketing.png": 4005,
	"./order.png": 224,
	"./payment.png": 6929,
	"./setting.png": 6170,
	"./stores.png": 73,
	"./survey.png": 365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4760;